import { useProjectStore } from '@/core/project/store/project.store'
import { lexicalNodes } from '@/features/screenplay/components/editor/nodes/NodeCore'
import {
    setJsonScriptEditor
} from '@/features/screenplay/components/editor/utils/JsonUtils'
import { useScreenplayQuery } from '@/features/screenplay/queries/screenplay.queries'
import { LexicalComposer } from '@lexical/react/LexicalComposer'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { LexicalEditor } from 'lexical'
import { useEffect, useState } from 'react'
import { useSceneStore } from '../stores/scene.store'

// We need a minimal editor to load the content and let the Provider extract scenes
export default function HeadlessSpEditor() {
    const { project } = useProjectStore()

    const [jsonScript, setJsonScript] = useState<any[] | undefined>(undefined)
    const fileName = 'master'

    const { data: screenplayEntity } = useScreenplayQuery(project?.id, fileName)
    // 1. Fetch Screenplay
    useEffect(() => {
        setJsonScript(screenplayEntity?.content)
    }, [screenplayEntity])

    // 2. Prepare JSON for Editor

    if (!jsonScript) return null

    return (
        <LexicalComposer
            initialConfig={{
                namespace: 'HeadlessEditor',
                nodes: [...lexicalNodes.map(([_type, node]: any) => node.kClass)],
                onError: (e) => { throw e },
                editorState: (initialEditor: LexicalEditor) => {
                    setJsonScriptEditor(initialEditor, jsonScript)
                },
                editable: false // Important: Read-only
            }}
        >
            <HeadlessEditorInstancePlugin />
        </LexicalComposer>
    )
}

function HeadlessEditorInstancePlugin() {
    const { setEditor } = useSceneStore()
    const [editor] = useLexicalComposerContext()

    useEffect(() => {
        setEditor(editor)
    }, [editor, setEditor])

    return null
}


